if (!customElements.get('media-gallery')) {
    customElements.define(
        'media-gallery',
        class MediaGallery extends HTMLElement {
            constructor() {
                super();

                const mainEl = this.querySelector('.slideMain');
                const thumbEl = this.querySelector('.slideChild');

                if (!mainEl || !thumbEl || !window.Swiper) return;

                this.thumbSwiper = new Swiper(thumbEl, {
                    spaceBetween: 10,
                    slidesPerView: 6,
                    freeMode: true,
                    watchSlidesProgress: true,
                    observer: true,
                    observeParents: true,
                });
                this.mainSwiper = new Swiper(mainEl, {
                    spaceBetween: 10,
                    slidesPerView: 1,
                    "autoHeight": true,
                    navigation: {
                        nextEl: this.querySelector('.swiper-button-next-product'),
                        prevEl: this.querySelector('.swiper-button-prev-product'),
                    },
                    thumbs: {
                        swiper: this.thumbSwiper,
                    },
                    observer: true,
                    observeParents: true,
                });
            }

            setActiveMedia(mediaId) {
                if (!this.mainSwiper) return;

                const slides = Array.from(
                    this.mainSwiper.slides
                );

                const index = slides.findIndex(
                    (slide) => String(slide.dataset.mediaId) === String(mediaId)
                );

                if (index === -1) return;

                this.mainSwiper.slideTo(index, 300);
            }
        }
    );
}
